import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0e97c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "u-emoji" }
const _hoisted_2 = { class: "face-tooltip-head select-none" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "emoji-body select-none" }
const _hoisted_6 = { style: {"padding":"0 5px"} }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "emoji-btn select-none" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-v-9fe533ba": "",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.00002 0.666504C12.0501 0.666504 15.3334 3.94975 15.3334 7.99984C15.3334 12.0499 12.0501 15.3332 8.00002 15.3332C3.94993 15.3332 0.666687 12.0499 0.666687 7.99984C0.666687 3.94975 3.94993 0.666504 8.00002 0.666504ZM8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM10.6667 5.66667V7.66667H9.33333V5.66667H10.6667ZM6.66667 5.66667V7.66667H5.33333V5.66667H6.66667ZM10.0767 9.33333H11.0495C11.1804 9.33333 11.2866 9.43951 11.2866 9.57048C11.2866 9.60754 11.2779 9.64409 11.2612 9.67718L11.244 9.71053C10.6294 10.8739 9.40726 11.6667 7.99998 11.6667C6.61523 11.6667 5.40977 10.8991 4.7859 9.76612L4.73786 9.67593C4.67845 9.56052 4.72385 9.4188 4.83926 9.35939C4.87253 9.34226 4.90941 9.33333 4.94683 9.33333H5.92347C6.02396 9.33332 6.11908 9.37865 6.18238 9.4567C6.26207 9.55496 6.32833 9.62955 6.38117 9.68046C6.80074 10.0847 7.37133 10.3333 7.99998 10.3333C8.63289 10.3333 9.20694 10.0814 9.62728 9.67224C9.67791 9.62296 9.74135 9.55121 9.8176 9.45698C9.88089 9.37877 9.97611 9.33333 10.0767 9.33333Z"
  })
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表情", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { ref } from 'vue'
import { EmojiApi } from '~/components'

interface Props {
  emoji: EmojiApi
  placement?: any
}

export default /*#__PURE__*/_defineComponent({
  __name: 'emoji',
  props: {
    emoji: null,
    placement: { default: 'bottom' }
  },
  emits: ["addEmoji"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'addEmoji', key: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { emoji: EmojiApi, placement: any }



const activeIndex = ref(0)
const offsetX = ref(0)
const emojis = ref(new Array(2))
const { emojiList, faceList } = props.emoji as EmojiApi



function change(val: number) {
  activeIndex.value = val
  switch (val) {
    case 0:
      offsetX.value = 0
      break
    case 1:
      offsetX.value = -50
      emojis.value[1] = emojiList[1]
      break
  }
}

function onBefore() {
  emojis.value[0] = emojiList[0]
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      placement: __props.placement,
      "popper-class": "emoji-popover",
      width: 250,
      trigger: "click",
      onBeforeEnter: onBefore
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          (!_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : _renderSlot(_ctx.$slots, "default", { key: 1 })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(faceList), (item, index) => {
            return (_openBlock(), _createElementBlock("label", {
              key: index,
              class: _normalizeClass(activeIndex.value == index ? 'active' : ''),
              onClick: ($event: any) => (change(index))
            }, [
              _createElementVNode("img", {
                src: item,
                alt: ""
              }, null, 8, _hoisted_4)
            ], 10, _hoisted_3))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "emjio-container",
            style: _normalizeStyle({ transform: `translateX(${offsetX.value}%)` })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(emojis.value, (list, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "emoji-wrapper"
              }, [
                _createVNode(_component_el_scrollbar, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list, (value, key) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: key,
                          class: "emoji-item",
                          onClick: ($event: any) => (_ctx.$emit('addEmoji', key as unknown as string))
                        }, [
                          _createVNode(_component_el_image, {
                            src: value,
                            title: String(key),
                            class: "emoji",
                            style: {"width":"24px","height":"24px","margin":"5px"},
                            lazy: ""
                          }, null, 8, ["src", "title"])
                        ], 8, _hoisted_7))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ], 4)
        ])
      ]),
      _: 3
    }, 8, ["placement"])
  ]))
}
}

})